// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__pMkHg","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Akak"};